import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { LoginService } from '../services/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { googleProvider } from 'src/environments/environment';
import { filter, Observable, Subscription, take, tap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import {
	SocialUser,
	GoogleLoginProvider,
	SocialAuthService,
	FacebookLoginProvider,
} from '@abacritt/angularx-social-login';
import { Store } from '@ngrx/store';
import { authentication } from '@biz-action/user-actions/auth-login.actions';
import { isLoading } from '@biz-store/auth/feature.selectors';
import { IsAuthenticated } from '@biz-selectors/app.selectors';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
	readonly googleProvider = googleProvider;
	loginForm: UntypedFormGroup;
	user: SocialUser;
	loggedIn: boolean;
	GoogleLoginProvider = GoogleLoginProvider;
	socialLoginForm: UntypedFormGroup;

	apiError: any = [];
	authServiceSubscription: Subscription;
	images: any = [];
	today = new Date();
	// *** date object month is start on 0
	event_startdate = new Date(2023, 10, 8, 0, 0, 0);
	event_enddate = new Date(2024, 4, 3, 23, 59, 59);
	sst_2024_startdate = new Date(2024, 1, 19, 0, 0, 0);
	sst_2024_enddate = new Date(2024, 1, 29, 23, 59, 59);
	fb_enddate = new Date(2024, 1, 4, 23, 59, 59);
	image: any;
	isLoading$: Observable<boolean>;

	multipleSubdomain$: Observable<boolean>;

	isMobile = window.innerWidth <= 768;
	footerLogos = [
		{ src: 'assets/footer/iso27001.png', alt: 'ISO 27001' },
		{ src: 'assets/footer/md.png', alt: 'Malaysia Digital' },
	];
	constructor(
		public translate: TranslateService,
		private formBuilder: UntypedFormBuilder,
		private authService: SocialAuthService,
		private loginService: LoginService,
		private route: ActivatedRoute,
		private router: Router,
		private store: Store,
	) {}

	ngOnInit(): void {
		this.store
			.select(IsAuthenticated)
			.pipe(
				take(1),
				filter((r) => !!r),
				tap(() => this.router.navigate(['account'], { queryParamsHandling: 'preserve' })),
			)
			.subscribe();

		localStorage.setItem('isLogin', 'false');
		this.isLoading$ = this.store.select(isLoading);
		var trial = Boolean(0);
		var subscriber = Boolean(0);
		var plans = ['ss', 's', 'm', 'l', 'xl', 'basic', 'plus', 'growth', 'pro', 'elite'];
		var plan = null;

		this.route.queryParamMap.subscribe((params) => {
			if (params.get('trial')) {
				trial = Boolean(JSON.parse(params.get('trial')));
			}
			if (params.get('subscriber')) {
				subscriber = Boolean(JSON.parse(params.get('subscriber')));
			}
			if (params.get('plan')) {
				plan = Number(JSON.parse(params.get('plan')));
				plan = plans[plan];
			}
		});

    // default
    this.images = ['tax_2024', 'feature_non_subscriber', 'hrdc_funding_non_subscriber', 'ISO'];

		if (subscriber) {
			this.images = ['referral_2024', 'tax_2024', 'feature_subscriber', 'hrdc_funding', 'ISO'];
		} else if (this.today > this.sst_2024_startdate && this.today < this.sst_2024_enddate && trial) {
			this.images = ['sst_2024'];
		} else if (this.today < this.fb_enddate) {
			this.images = ['fb_live'];
		}
		if (['ss', 's', 'basic'].includes(plan)) {
			this.images.push('eInvoice_ready');
		}
		if (this.today < this.event_enddate) {
			this.images.push('grant_2024');
		}
		this.image = this.images[Math.floor(Math.random() * this.images.length)];
		this.loginForm = this.formBuilder.group({
			username: ['', [Validators.required]],
			password: ['', Validators.required],
			provider: ['website'],
			token: [''],
		});

		this.route.queryParamMap.subscribe((params) => {
			if (params.get('_subdomain')) {
				this.loginForm.addControl('_subdomain', new UntypedFormControl(''));
				this.loginForm.controls['_subdomain'].setValue(params.get('_subdomain'));
			}
		});
	}
	ngOnDestroy(): void {
		if (this.authServiceSubscription) {
			this.authServiceSubscription.unsubscribe();
			this.signOut();
		}
	}

	get login() {
		return this.loginForm.controls;
	}

	onLogin() {
		this.store.dispatch(authentication.logininit(this.loginForm.value));
	}

	signInWithGoogle(): void {
		this.store.dispatch(authentication.googlelogin());
		// this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
	}

	signInWithFB(): void {
		/* this.authServiceSubscription = this.authService.authState.subscribe((user) => {
			this.user = user;
			this.loggedIn = user != null;
			this.loginForm.controls['token'].setValue(this.user.authToken);
			this.loginForm.controls['provider'].setValue('facebook');
			this.loginForm.controls['username'].clearValidators();
			this.loginForm.controls['password'].clearValidators();
			this.loginForm.controls['username'].updateValueAndValidity();
			this.loginForm.controls['password'].updateValueAndValidity();

			this.onSocialLogin();
		}); */
		// this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
		this.store.dispatch(authentication.fblogin());
	}

	signOut(): void {
		this.authService.signOut();
	}

	refreshGoogleToken(): void {
		// this.authService.refreshAuthToken(GoogleLoginProvider.PROVIDER_ID);
		// console.log(this.user.authToken);
	}
}
